export default IconCirclePlus2 => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-circle-plus-2" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M20.985 12.522a9 9 0 1 0 -8.475 8.464" />
  <path d="M16 19h6" />
  <path d="M19 16v6" />
</svg>`;